import { View } from '@react-pdf/renderer';

import { container } from './styles';

export function HeaderRoot({ children }) {
  return (
    <View style={container} fixed>
      {children}
    </View>
  )
}
